<div id="demo-modal" class="modal">
    <div class="modal__content">
        <ng-content></ng-content>
    </div>
</div>  